import {React} from 'common'
import {Controller, useFormContext} from 'react-hook-form'
import Autocomplete from '../Autocomplete'
import {getDocumentId} from 'utils'
import {useTranslation} from 'react-i18next'

const FormAutocomplete = ({
    name,
    options,
    label,
    i18nCategory,
    defaultValue,
    error,
    rules,
    readOnly,
    ...p
}) => {
    const {t} = useTranslation()
    const {control} = useFormContext()

    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({field: {onChange}}) => (
                <Autocomplete
                    {...p}
                    disabled={readOnly}
                    defaultValue={defaultValue}
                    label={t(`${i18nCategory}.${label}`)}
                    options={options}
                    onChange={(e, newValue) => {
                        onChange(getDocumentId(newValue))
                    }}
                    error={!!error}
                    helperText={error?.message && t(`error.${error?.message}`)}
                    isFilter={false}
                />
            )}
        />
    )
}

export default FormAutocomplete
